<div #modal [ngClass]="fullScreen ? 'full-screen' : 'normal'" class="modal overlay-black">
  <div #content class="content pad" tabindex="-1">
    <ng-content></ng-content>
    <button ds-button class="close icon-exit" title="Close" (click)="close()"></button>
  </div>
</div>
